// 사진 사용을 골라야 하는 체험단 값(할인 체험단 / 일반 예약)인데 고르지 않고 온 손님(컨셉 화면·디엠 링크)은
// 고르기 창이 있는 신작 페이지로 보내고 창을 바로 연다. 고르지 않으면 결제 때 서버가 막는다(10/19 그라나다 링크 손님)
import { isPromotionLinkOpen } from "@/util/promotionWindow"

const needsChoice = (products) => products.some((product) => typeof product.photoUsageConsent !== "boolean" && Number(product.photoUsagePrivateSurcharge) > 0)

const parseProducts = (promotion) => {
  try {
    const products = Array.isArray(promotion.products) ? promotion.products : JSON.parse(promotion.products || "[]")
    return Array.isArray(products) ? products : []
  } catch (e) {
    return []
  }
}

async function choiceHref(conceptId, traveler) {
  let href = "/funding"
  try {
    const res = await fetch("/api/funding/projects", { cache: "no-store" })
    const projects = res.ok ? await res.json() : []
    const project = Array.isArray(projects) && projects.find((item) => Number(item.conceptId) === Number(conceptId))
    if (project && project.href) href = `${project.href}${project.href.includes("?") ? "&" : "?"}choose=photo`
  } catch (e) {
    console.error("funding project lookup failed", e)
  }
  if (/^[A-Za-z0-9_-]{1,50}$/.test(String(traveler || ""))) href += `${href.includes("?") ? "&" : "?"}traveler=${encodeURIComponent(traveler)}`
  return href
}

// promotion: 이미 불러온 할인 줄. 없으면 code로 불러온다. 보냈으면 true
export async function sendToPhotoUseChoice({ promotion, code, photoUse, traveler }) {
  if (photoUse === "agree" || photoUse === "private") return false
  let row = promotion
  if (!row && code) {
    try {
      const res = await fetch(`/api/promotion/select/code?code=${encodeURIComponent(code)}`, { cache: "no-store" })
      const rows = res.ok ? await res.json() : []
      row = Array.isArray(rows) ? rows.find((item) => item && item.code === code) : null
    } catch (e) {
      return false
    }
  }
  // 닫힌 할인은 신작 페이지도 예약 길을 내주지 않으므로 보내지 않는다(오가며 맴돌지 않게)
  if (!row || !row.conceptId || !isPromotionLinkOpen(row) || !needsChoice(parseProducts(row))) return false
  window.location.replace(await choiceHref(row.conceptId, traveler))
  return true
}
